import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { switchMap, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AppProfile } from '../shared/app-profile/app-profile';

@Injectable({ providedIn: 'root' })
export class UserApiService {
  constructor(
    private readonly http: HttpClient,
    private readonly appProfile: AppProfile
  ) {}

  activateUser(userId: string, authToken: string): Observable<any> {
    const url = `${this.appProfile.epUs}/user-management-ms/users/42a0efa8-9b2f-4f55-a30a-8dec654a37b7/activate`;
    const headers = new HttpHeaders({
      'auth-token': authToken,
      'api-version': '1.0.0',
      'Content-Type': 'application/json',
      'userId': '42a0efa8-9b2f-4f55-a30a-8dec654a37b7',
    });
    return this.http.post<any>(url, {}, { headers });
  }

  deactivateUser(userId: string, authToken: string): Observable<any> {
    const url = `${this.appProfile.epUs}/user-management-ms/users/${userId}/deactivate`;
    const headers = new HttpHeaders({
      'auth-token': authToken,
      'api-version': '1.0.0',
      'Content-Type': 'application/json',
      'userId': userId,
    });
    console.log(userId);
    return this.http.post<any>(url, {}, { headers });
  }

  getToken(): Observable<string> {
    const url =
      'https://iam-integration.us-east.philips-healthsuite.com:443/authorize/oauth2/token';
    const headers = new HttpHeaders({
      Authorization: 'Basic c3VydmV5ZGV2OlN1cnZleWRldkAyMg==',
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
      'api-version': '2',
    });
    const body = new HttpParams()
      .set('grant_type', 'password')
      .set('username', 'testampmkst')
      .set('password', 'Philips@123');
    return this.http
      .post<any>(url, body, { headers })
      .pipe(map((res) => res.access_token));
  }

  getUsers(token: string, orgId: string): Observable<any> {
    const url = `${this.appProfile.epUs}/mst/_search/1`;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'KAFKA-TOPIC': `STREAM.${this.appProfile.env}.EP.TP.FCT.UPSERT.USER.0`,
      'SEARCH-TYPE': 'VALUE',
      'SEARCH-VALUE': orgId,
    });
    return this.http.get<any>(url, { headers });
  }

  getUsersWithToken(orgId: string): Observable<any> {
    return this.getToken().pipe(
      switchMap((token) => this.getUsers(token, orgId))
    );
  }

  updateUser(
    userId: string,
    userData: any,
    authToken: string
  ): Observable<any> {
    const url = `${this.appProfile.epUs}/user-management-ms/users/${userId}`;
    const headers = new HttpHeaders({
      'auth-token': authToken,
      'api-version': '1.0.0',
      'Content-Type': 'application/json',
    });
    return this.http.put<any>(url, userData, { headers });
  }
}
